// extracted by mini-css-extract-plugin
export default {"container":"WaitingForPayment_container__lihsd","loader":"WaitingForPayment_loader__aWM8X","spin":"WaitingForPayment_spin__pC0Ne"};